import React, { Component } from 'react'
class statusVerify extends Component {
    render () {
        switch (this.props.status) {
            case 'active':
                return <span className="badge badge-success">Active</span>;
            case 'reject':
                return <span style={{backgroundColor:'#d92550'}} className="badge badge-danger">Reject</span>;
            case 'block':
                return <span style={{backgroundColor:'#d92550'}} className="badge badge-danger">Block</span>;
            case 'pending':
                return <span className="badge badge-warning">Pending</span>;
            case 'expired':
                return <span className="badge badge-dark">Expired</span>;
            default :
                return <span>-</span>
        }
    }
}

statusVerify.defaultProps = {
    status: ''
}

export default statusVerify;
